module.exports = __webpack_public_path__ + "images/dig-naagriks.3d2c7309.webp";